var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { defaultPanelProps } from './defaults';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
import { ArrowDownOutlined } from '@feb-team/legao-icons-react';
import CollapseTransition from '../CollapseTransition';
var CollapsePanel = /** @class */ (function (_super) {
    __extends(CollapsePanel, _super);
    function CollapsePanel(props) {
        var _this = _super.call(this, props) || this;
        _this.componentWillReceiveProps = function (nextProps) {
            var that = _this;
            setTimeout(function () {
                that.setState({
                    clientHeight: nextProps.isActive ? that.panel && that.panel.clientHeight : 0,
                });
            }, 100);
            setTimeout(function () {
                that.setState({
                    clientHeight: nextProps.isActive ? 'auto' : 0,
                });
            }, 300);
        };
        _this.transformPanel = function () {
            var _a = _this.props, panelKey = _a.panelKey, onChange = _a.onChange, onItemChange = _a.onItemChange, isActive = _a.isActive;
            _this.setState({
                clientHeight: isActive ? _this.panel && _this.panel.clientHeight : 0,
            });
            onItemChange && onItemChange(panelKey);
            onChange(!_this.props.isActive, panelKey);
        };
        _this.renderHeader = function () {
            var headerCls = [
                'relative',
                'px-px-12',
                'py-px-12',
                'bg-white',
                'flex',
                'items-center',
                'cursor-pointer',
            ];
            var svgCls = [
                'w-3',
                'h-3',
                'mr-px-16',
                'transform',
                'transition-all',
                'duration-slow',
                'ease-linear',
            ];
            var svgRightCls = ['absolute', 'right-0', 'left-auto', 'top-auto'];
            var disabledCls = ['text-gray-400', 'cursor-not-allowed'];
            var _a = _this.props, iconPosition = _a.iconPosition, header = _a.header, disabled = _a.disabled, isActive = _a.isActive, icon = _a.icon, extra = _a.extra;
            var extraCls = [iconPosition == 'right' ? 'mr-px-21' : null];
            var svgIcon;
            switch (typeof icon) {
                case 'boolean':
                    svgIcon = icon ? (
                    // <ArrowDownOutlined
                    //   className={`${svgCls.join(' ')} ${isActive ? 'rotate-0' : '-rotate-90'} ${
                    //     iconPosition == 'right' ? svgRightCls.join(' ') : ''
                    //   } fill-gray-${disabled ? '400' : '700'}`}
                    // />
                    React.createElement(ArrowDownOutlined, { className: "collapse-header-arrow-svg " + (isActive ? 'collapse-svg-rotate-0' : 'collapse-svg-rotate-90') + " " + (iconPosition == 'right' ? 'collapse-svg-right' : '') + " collapse-svg-fill-gray-" + (disabled ? '400' : '700') })) : ('');
                    break;
                default:
                    svgIcon = icon;
            }
            if (disabled)
                headerCls = headerCls.concat(disabledCls);
            return (React.createElement(DivTag, { autoPrefixedClassName: "collapse-header", atomics: headerCls, onClick: _this.transformPanel },
                svgIcon,
                React.createElement(SpanTag, { atomics: 'flex-1' }, header),
                extra && (React.createElement(DivTag, { atomics: extraCls, onClick: function (e) { return e.stopPropagation(); } }, extra))));
        };
        _this.state = {
            clientHeight: 0,
        };
        return _this;
    }
    CollapsePanel.prototype.componentDidMount = function () {
        var isActive = this.props.isActive;
        var that = this;
        setTimeout(function () {
            that.setState({
                clientHeight: isActive ? 'auto' : 0,
            });
        }, 100);
    };
    CollapsePanel.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, hasBorder = _a.hasBorder, accordion = _a.accordion, isActive = _a.isActive, onItemChange = _a.onItemChange, iconPosition = _a.iconPosition, panelKey = _a.panelKey, header = _a.header, onChange = _a.onChange, icon = _a.icon, extra = _a.extra, panelrest = __rest(_a, ["children", "hasBorder", "accordion", "isActive", "onItemChange", "iconPosition", "panelKey", "header", "onChange", "icon", "extra"]);
        var boxCls = ['text-sm'];
        var boxBorderCls = ['border-b', 'border-solid', 'border-gray-200'];
        var contentCls = ['border-solid', 'border-gray-200', 'bg-gray-100'];
        if (hasBorder)
            boxCls = boxCls.concat(boxBorderCls);
        return (React.createElement(DivTag, __assign({ atomics: boxCls, name: CollapsePanel.NAME }, panelrest),
            this.renderHeader(),
            React.createElement(CollapseTransition, { in: isActive },
                React.createElement(DivTag, { autoPrefixedClassName: 'collapse-body', atomics: contentCls },
                    React.createElement(DivTag, { atomics: 'p-px-16', ref: function (c) {
                            _this.panel = c;
                        } },
                        hasBorder,
                        " ",
                        children)))));
    };
    CollapsePanel.defaultProps = defaultPanelProps;
    CollapsePanel.NAME = 'collapse-panel';
    return CollapsePanel;
}(React.PureComponent));
export { CollapsePanel };
